window.countWords = function(s){
  s = s.replace(/(^\s*)|(\s*$)/gi,"");//exclude  start and end white-space
  s = s.replace(/[ ]{2,}/gi," ");//2 or more space to 1
  s = s.replace(/\n /,"\n"); // exclude newline with a start spacing
  return s.split(' ').length;
}
//This is the functionality for the entrant
var customFieldIdHolder = false;

EMMY.entrants = {
  init: function () {
    EMMY.entrants.activeFormAjaxCall = false;
    EMMY.entrants.loadNewFormAfterSave = false;
    Dropzone.autoDiscover = false;
    EMMY.entrants.minRequired = ['.form-control.firstname', '.form-control.lastname', '.form-control.email'];
    EMMY.entrants.entryId = document.getElementById('entryId').innerText;
    EMMY.entrants.numCount = Number(document.getElementById('numEntrantsCount').getAttribute('data-total-entrants'));
    // We need this variable below otherwise we can duplicate entrant information bringing in a form with the same index value ie: entrant[index]first_name
    EMMY.entrants.lowestWeightForNewForm = EMMY.entrants.numCount;
    EMMY.entrants.maxEntrants = Number($('.entrant-form-wrapper').attr('data-max-entrants'));
    EMMY.entrants.maxPetitionEntrants = Number($('.entrant-form-wrapper').attr('data-max-petition'));
    EMMY.entrants.maxEntrantsIncludingPetitions = EMMY.entrants.maxEntrants + EMMY.entrants.maxPetitionEntrants;
    EMMY.entrants.approvedEntrants = $('.entrant-left li.entrant-approved').length;

    // Now we do a calculation to take care of the approved entrants. ie: that entry gets a new max and max petitions goes down by one.
    EMMY.entrants.maxEntrants = EMMY.entrants.maxEntrants + EMMY.entrants.approvedEntrants;
    if(EMMY.entrants.maxPetitionEntrants != -1) {
      EMMY.entrants.maxPetitionEntrants = EMMY.entrants.maxPetitionEntrants - EMMY.entrants.approvedEntrants;
    }

    EMMY.entrants.bindListing();
    EMMY.entrants.clickableListing();
    EMMY.entrants.ajaxBlurActiveSave = true;
    EMMY.entrants.ajaxBlurEntrant();
    EMMY.entrants.deleteEntrant();
    EMMY.entrants.checkEntrants();
    EMMY.entrants.checkPetitionEntrants();
    EMMY.entrants.initialDependentFieldShowHide();
    EMMY.entrants.dependentFields();

    var createEntrant = document.getElementById('createNewEntrant');
    EMMY.entrants.activeFormAjaxCall = true;
    createEntrant.addEventListener('click', function (e) {
      e.preventDefault();
      EMMY.entrants.breakVal = true;
      if ($('.entrant-listing-item.not-saved').val() == undefined) {
        if (!EMMY.entrants.activeFormAjaxCall) {
          return;
        }
        if(!EMMY.entrants.ajaxBlurActiveSave) {
            EMMY.entrants.loadNewFormAfterSave = true;
            return;
        }
        EMMY.entrants.bringNewForm();
      }
    });

    if($('#entrant-listing-overlimit li').length > 0) {
      $('#entrant-listing-overlimit').show();
    }
  },
  ajaxBlurEntrant: function (saveEntryToo) {
    // console.log("ajaxBlurEntrant")
    // var activeAjaxCall = true;
    var ajaxbind = function () {
      // console.log(EMMY.entrants.ajaxBlurActiveSave, 'active ajax call value')
      if (!EMMY.entrants.ajaxBlurActiveSave) {
        return;
      }
      EMMY.entrants.ajaxBlurActiveSave = false;

      // Truncate max word count to MAX number if over before saving;
      $('.blurSave:not(.entryAdmin) #entrants-form-block .form-control.word-count').each(function(i,v) {
        var that = $(this);
        EMMY.blurSave.maxWordCountRemoveOver(that);
      });

      var entrantInQuestion = $(this).closest('.entrant-item');
      var entrantNumPreAjax = $(this).closest('.entrant-item').find('.entrantIdVal').val();

      // assign the production company and agency values on commercial entries
        // AWARDS-1722 Dec, 2024
      if ($(this).hasClass('on_air_credit') && $('.ad_agency_prod_co').length && $('.prod_co').length) {
          var on_air_credit = entrantInQuestion.find('.on_air_credit').val();
          // ad_agency_prod_co and prod_co
          var ad_agency_prod_co = $('.ad_agency_prod_co').val();
          var prod_co = $('.prod_co').val();
          if (on_air_credit === 'Ad Agency' && ad_agency_prod_co) {
              entrantInQuestion.find('.entrant_company').val(ad_agency_prod_co);
          } else if (on_air_credit === 'Production Company' && prod_co) {
              entrantInQuestion.find('.entrant_company').val(prod_co);
          }
      }

      if ($(this).hasClass('last_name') || $(this).hasClass('first_name') || $(this).hasClass('imis-entrant-form-field')) {
        var imisId = entrantInQuestion.find('.imis-entrant-form-field').val();
        var lastName = entrantInQuestion.find('.last_name').val();
        var firstName = entrantInQuestion.find('.first_name').val();
        var entrantformFieldGroup = entrantInQuestion.find('.imis-entrant-form-field').closest('.form-group-beside');
        var entrantIdVal = entrantInQuestion.find('.entrantIdVal').val();
        if(imisId) {    // Only want to run this ajax check if imis id isn't blank.
          $.ajax({
            url: "/api/entrants/validate/validate_imis_voucher",
            method: 'POST',
            data: {'imis_id': imisId, 'last_name': lastName, 'first_name': firstName}, // replace with actual fields. should show error. shange to 'Ableson' to get warning about voucher
            success: function (data) {
              if ((entrantInQuestion.find('.imis-entrant-form-field').val().length > 0) && (data.responseText == 'Imis Ok')) {
                EMMY.entrants.removeIMISBlocker(entrantformFieldGroup, entrantInQuestion, entrantIdVal);
              }
            },
            error: function (jqXHR, textStatus, errorThrown) {
              // remove the old errors before rechecking
              EMMY.entrants.removeIMISBlocker(entrantformFieldGroup, entrantInQuestion, entrantIdVal);
              if (entrantInQuestion.find('.imis-entrant-form-field').val().length > 0) {
                data = JSON.parse(jqXHR.responseText);
                entrantformFieldGroup.find('.info-placeholder-text').addClass('not-valid');
                entrantformFieldGroup.find('.info-placeholder-text').text(data.errors[0]);
                entrantInQuestion.find('.imis-entrant-form-field').addClass('imis-confirmed');
                var errorResponse = data.errors[0];
                if (errorResponse.indexOf('does not match') > 0) {
                  entrantInQuestion.find('.imis-entrant-form-field').removeClass('imis-confirmed');
                  entrantInQuestion.find('.imis-entrant-form-field').closest('.form-group-beside').addClass('required');
                  $('.entrant-left .entrant-listing-item-'+entrantIdVal).addClass('needsAttention');
                  entrantInQuestion.find('.imis-entrant-form-field').addClass('imis-needsfixing');
                }
              }
            }
          });
        } else {
          // This is when IMIS ID is blank -- need to clear out the previous functionality
          EMMY.entrants.removeIMISBlocker(entrantformFieldGroup, entrantInQuestion, entrantIdVal);
        }
      }

      setTimeout(function() {
      var dataForm = $('#entrants-form-block').serialize();
      // console.log(dataForm, 'aaa')
      var URL = '/entry/' + EMMY.entrants.entryId + '/entrants';
      $.ajax({
        url: URL,
        method: 'PUT',
        data: dataForm,
        success: function (data) {
          // console.log('data saved', data, entrantNumPreAjax, entrantNumPreAjax == 0)
          var mainWrapper = document.querySelector('.main');
          mainWrapper.className = 'main oneColumn col-8 col-md-10 editPage ' + data.status;
          $('.submission-status-value').text(data.status);

          var entrantArray = data.entrantArray;
          var entrantNum;
          if(entrantArray != undefined) {
              entrantNum = entrantArray[entrantArray.length - 1];
          }
          // console.log(entrantArray, 'AJAX save', entrantArray.length, '-', entrantArray[entrantArray.length - 1], $(this).closest('.entrant-item').attr('class'))
          // console.log(entrantNum, ' --- ', $('.entrant-left .entrant-listing-item.not-saved').val() != undefined, entrantNum != '')
          if (($('.entrant-left .entrant-listing-item.not-saved').val() != undefined) && (entrantNum != '')) {
            var entryItem = '.entrant-listing-item.not-saved';
            $('.entrant-right ' + entryItem).data('entrant-item', entrantNum);
            $('.entrant-right ' + entryItem + ' .entrantIdVal').val(entrantNum);
            document.querySelector(entryItem).setAttribute('data-entrant-num', entrantNum);
            $(entryItem).removeClass('entrant-listing-item-not-saved').removeClass('entrant-');
            $(entryItem).addClass('entrant-listing-item-' + entrantNum);

            $('.entrant-right ' + entryItem).find('.first_name').trigger('change');
            $('.entrant-right ' + entryItem).find('.middle_name').trigger('change');
            $('.entrant-right ' + entryItem).find('.entrant_suffix').trigger('change');
            $('.entrant-right ' + entryItem).find('.last_name').trigger('change');

            $(entryItem).removeClass('not-saved');
            entrantNumPreAjax = entrantNum;
            $('.entrant-listing .noclick').removeClass('noclick');
            EMMY.entrants.numberingEntrants();
            EMMY.entrants.checkEntrants();
            EMMY.entrants.checkPetitionEntrants();
            // console.log('save finished and was triggered?', EMMY.entrants.ajaxBlurActiveSave)
          } else {
            // console.log('save finished but nothing triggered')
          }

          if(EMMY.entrantAutocomplete.finishingLoop) {
            //console.log('running save again, doing this so that we activate a save after autofill is completed');
            EMMY.entrants.ajaxBlurActiveSave = true;
            EMMY.entrantAutocomplete.finishingLoop = false;
            ajaxbind();
          } else {
            // console.log('not running save again');
            EMMY.entrants.ajaxBlurActiveSave = true;
          }
          if(EMMY.entrants.loadNewFormAfterSave) {
              EMMY.entrants.bringNewForm();
          }
        },
        error: function (jqXHR, textStatus, errorThrown) {
          console.log('Error saving data')
        }
      })
      }, 100);
    }

    // This is used to save the entry too when they click the save button on admin view.
    if (saveEntryToo) {
      ajaxbind();
    }

      $('.entrant-right .form-control').on('change', ajaxbind);
      $('.entrant-right .file-upload-beside div').on('click', ajaxbind);
  },
  removeIMISBlocker: function(entrantformFieldGroup, entrantInQuestion, entrantIdVal) {
    entrantformFieldGroup.find('.info-placeholder-text').removeClass('not-valid');
    entrantformFieldGroup.find('.info-placeholder-text').text("Enter 6-digit Number To Receive Entry Discount");
    entrantInQuestion.find('.imis-entrant-form-field').closest('.form-group-beside').removeClass('required');
    $('.entrant-left .entrant-listing-item-'+entrantIdVal).removeClass('needsAttention');
    entrantInQuestion.find('.imis-entrant-form-field').attr('required', false);
    entrantInQuestion.find('.imis-entrant-form-field').removeClass('imis-needsfixing');
  },
  clearPlaceholderText: function (activeListing, activeForm) {
    var nameSelect = activeListing.querySelector('.firstname');
    var TextVal = nameSelect.innerText;
    if (TextVal == 'Entrant Name') {
      activeListing.querySelector('.firstname').innerHTML = '';
    }
  },
  bindListing: function () {
    if ((document.querySelector('.entrant-item.active')) && (!document.querySelector('.entrantsLocked'))) {
      var activeForm = document.querySelector('.entrant-item.active');
      var activeListingJquery = $('.entrant-listing');
      var noSavedAdminEntrants = activeListingJquery.find('.entrant-listing-item-0.not-saved').length;

        if($('.entrant-credit-appeal-wrapper').length > 0) {
            // loop through all entrants and turn required on off depending on entrant credit.
            $('.entrant-item .appeal-field').hide();
            $('.entrant-item input.on_air_credit_other').removeAttr('required');
            $('.entrant-item .appeal-field textarea').removeAttr('required');
        }

      $(document).on('change', '.first_name', function (e) {
        $(this).parent().remove('required');
        var entrantItem = $(this).closest('.entrant-item').find('.entrantIdVal').val();
        if ((entrantItem == '') && ($('.entryAdmin').length == 1)) {
          if (noSavedAdminEntrants) {
            entrantItem = '0.not-saved';
          } else {
            entrantItem = 'not-saved';
          }
        }
        var nameSelect = activeListingJquery.find('.entrant-listing-item-' + entrantItem + ' .firstname');
        nameSelect.addClass('name firstname').removeClass('placeholder');
        nameSelect.text($(this).val());
      })

      $(document).on('change', '.middle_name', function (e) {
        $(this).parent().remove('required');
        var entrantItem = $(this).closest('.entrant-item').find('.entrantIdVal').val();
        if ((entrantItem == '') && ($('.entryAdmin').length == 1)) {
          if (noSavedAdminEntrants) {
            entrantItem = '0.not-saved';
          } else {
            entrantItem = 'not-saved';
          }
        }
        var nameSelect = activeListingJquery.find('.entrant-listing-item-' + entrantItem + ' .middlename');
        nameSelect.addClass('name middlename').removeClass('placeholder');
        nameSelect.text($(this).val());
      })

      $(document).on('change', '.entrant_suffix', function (e) {
        $(this).parent().remove('required');
        var entrantItem = $(this).closest('.entrant-item').find('.entrantIdVal').val();
        if ((entrantItem == '') && ($('.entryAdmin').length == 1)) {
          if (noSavedAdminEntrants) {
            entrantItem = '0.not-saved';
          } else {
            entrantItem = 'not-saved';
          }
        }
        var nameSelect = activeListingJquery.find('.entrant-listing-item-' + entrantItem + ' .entrantsuffix');
        nameSelect.addClass('name entrantsuffix').removeClass('placeholder');
        nameSelect.text($(this).val());
      })

      $(document).on('change', '.last_name', function (e) {
        $(this).parent().remove('required');
        var entrantItem = $(this).closest('.entrant-item').find('.entrantIdVal').val();
        if ((entrantItem == '') && ($('.entryAdmin').length == 1)) {
          if (noSavedAdminEntrants) {
            entrantItem = '0.not-saved';
          } else {
            entrantItem = 'not-saved';
          }
        }
        var nameSelect = activeListingJquery.find('.entrant-listing-item-' + entrantItem + ' .lastname');
        nameSelect.addClass('name lastname').removeClass('placeholder');
        nameSelect.text($(this).val());
      });

      $(document).on('change', '.entrant_company', function (e) {
        $(this).parent().remove('required');
        var entrantItem = $(this).closest('.entrant-item').find('.entrantIdVal').val();
        if ((entrantItem == '') && ($('.entryAdmin').length == 1)) {
          if (noSavedAdminEntrants) {
            entrantItem = '0.not-saved';
          } else {
            entrantItem = 'not-saved';
          }
        }
        var nameSelect = activeListingJquery.find('.entrant-listing-item-' + entrantItem + ' .entrant_company');
        nameSelect.addClass('name entrant_company').removeClass('placeholder');
        nameSelect.text($(this).val());
        if ($(this).val() != '') {
          activeListingJquery.find('.entrant-listing-item-' + entrantItem + ' .name-wrapper ').addClass('company');
        } else {
          activeListingJquery.find('.entrant-listing-item-' + entrantItem + ' .name-wrapper ').removeClass('company');
        }
      });

        // if using appeal hide fields that are for appeal
        if($('.entrant-credit-appeal-wrapper').length > 0) {
            var activeEntrantItem = $('.entrant-item.active');
            if($('.entrant-item.active .on_air_credit').val() == 'Other') {
                // Show entrant credit appeal fields if applicable
                activeEntrantItem.find('.appeal-field').show();
                activeEntrantItem.find('input.on_air_credit_other').attr('required', true);
                activeEntrantItem.find('.appeal-field textarea').attr('required', true);
            }
        }

      // Bind the On Air Credit
      var activeListing = document.querySelector('.entrant-listing li.active');
      var on_air_credit = activeForm.querySelector('.on_air_credit');
      if (on_air_credit) {
          if (on_air_credit.localName == 'select') {
          var on_air_credit_other = activeForm.querySelector('.on_air_credit_other');

          // Dropdown.
          $('.entrant-item.active .on_air_credit').on('change', function () {
            var credit = $(this).val();
            if (($(this).val() === 'Other') && ($('.entrant-credit-appeal-wrapper').length > 0)) {
                // Show entrant credit appeal fields if applicable
                activeEntrantItem.find('.appeal-field').show();
                activeEntrantItem.find('input.on_air_credit_other').attr('required', true);
                activeEntrantItem.find('.appeal-field textarea').attr('required', true);
                if($('.entryAdmin').length == 0) {
                    activeEntrantItem.find('.appeal_status').val('Pending');
                }
                // Check if there is a value in the other field.
              if (on_air_credit_other) {
                if (on_air_credit_other.value) {
                  credit = on_air_credit_other.value;
                }
              }
            } else {
                if($('.entrant-credit-appeal-wrapper').length > 0) {
                    activeEntrantItem.find('.appeal-field').hide();
                    activeEntrantItem.find('input.on_air_credit_other, .appeal-field textarea').val('');
                    activeEntrantItem.find('input.on_air_credit_other').removeAttr('required');
                    activeEntrantItem.find('.appeal-field textarea').removeAttr('required');
                    activeEntrantItem.find('.appeal_status').val('');
                }
            }
            if(credit != null) {
                var on_air = activeListing.querySelector('.air-credit');
                on_air.innerHTML = ' - ' + credit;
            }
          });


          if (on_air_credit_other) {
            on_air_credit_other.addEventListener('keyup', function (e) {
              if (on_air_credit.value === 'Other') {
                var on_air = activeListing.querySelector('.air-credit');
                var credit_other = 'Other';
                if (this.value) {
                  credit_other = this.value;
                }

                on_air.innerHTML = ' - ' + credit_other;
              }
            });
          }
        }
        else {
          // Textfield.
          on_air_credit.addEventListener('keyup', function (e) {
            this.parentElement.classList.remove('required');
            var on_air = activeListing.querySelector('.air-credit');
            on_air.innerHTML = ' - ' + this.value;
          });
        }
      }
    }
    var entrantListLength = Number($('#entrantList li').length) - Number(1);
    if (entrantListLength == 1) {
      $('#entrantList li .action-icons').addClass('hide-me');
    } else {
      $('#entrantList li .action-icons').removeClass('hide-me');
    }

  },
  bringNewForm: function () {
    EMMY.entrants.loadNewFormAfterSave = false;
    var idVal = Number(EMMY.entrants.lowestWeightForNewForm) + Number(1);
    bringNewFormAjaxSpecific(idVal);
  },
  cloneListing: function (idVal) {
    var currentNumEntrants = EMMY.entrants.numCount+1;
    // console.log(idVal, ' this is hte clone listing idval', currentNumEntrants, 'max entrants ==', EMMY.entrants.maxEntrants)
    if((currentNumEntrants <= EMMY.entrants.maxEntrants) || (EMMY.entrants.maxEntrants == 0) || (EMMY.entrants.maxPetitionEntrants == 0)) {
      var leftIdElement = 'entrant-listing-underlimit';
    } else {
      var leftIdElement = 'entrant-listing-overlimit';
      $('#entrant-listing-overlimit').show();
    }
    var fullList = document.getElementById(leftIdElement);
    var itemToClone = document.querySelector('.entrant-listing .hide-me');
    var cln = itemToClone.cloneNode(true);
    cln.setAttribute('data-weight-value', idVal);
    cln.setAttribute('data-entrant-num', 'not-saved');
    cln.classList.remove('entrant-listing-item-0');
    cln.classList.add('entrant-listing-item-not-saved');
    var spans = cln.querySelectorAll('.entrant-listing__item span');
    Array.prototype.forEach.call(spans, function (el, i) {
      el.innerHTML = '';
      if ($(el).hasClass('firstname')) {
        $(el).addClass('placeholder');
        el.innerHTML = 'Entrant Name';
      }
    });
    $('.entrant-listing .active').removeClass('active');
    cln.classList.remove('hide-me');
    cln.classList.add('not-saved');
    cln.classList.add('active');
    fullList.appendChild(cln);
  },
  clickableListing: function () {
    $('.entrant-listing li').off("click", function (event) {
      clickListing(event, this);
    });
    $('.entrant-listing li').on("click", function (event) {
      clickListing(event, this);
    });
  },
  // This is used to set the add new entrant button on the left
  checkEntrants: function () {
    var currentNumEntrants = EMMY.entrants.numCount+1;
    // console.log('maxEntrants', EMMY.entrants.maxEntrants, EMMY.entrants.maxPetitionEntrants, currentNumEntrants)

    if(EMMY.entrants.maxEntrants < 1) {
        // console.log('max entrant is 0; unlimited number of entrants. Always show new entrant button.');
        $('.max-entrants').hide();
        $('#createNewEntrant').show();
    } else if((EMMY.entrants.maxEntrants == 1) && (EMMY.entrants.maxPetitionEntrants == 0)) {
        // console.log(' Category is set at 1 entrant max, with no petitions. Never show entrant button.');
        $('.max-entrants').hide();
        $('#createNewEntrant').hide();
        $('.action-icons, .max-entrants:not(.has-petition-file)').hide();
    } else {
        // console.log(' Now set the add entrant button dynamically depending on number of entrants already in the category', currentNumEntrants, EMMY.entrants.maxEntrants, EMMY.entrants.maxEntrantsIncludingPetitions);
      if (currentNumEntrants < EMMY.entrants.maxEntrants) {
        // console.log(' Show button if less than max', EMMY.entrants.maxEntrants, currentNumEntrants);
        $('.temporary-message').hide();
        $('#createNewEntrant').show();
        $('#createNewEntrant span').text('Add another entrant to this entry')
      } else if ((currentNumEntrants == EMMY.entrants.maxEntrants) && (EMMY.entrants.maxPetitionEntrants != 0)) {
        // console.log(' This is the case when max entrants has been received and petitions are allowed');
        $('#createNewEntrant span').text('Add petitioned entrant')
        $('.temporary-message').show();
        $('#createNewEntrant').show();
      } else if ((currentNumEntrants > EMMY.entrants.maxEntrants) && (currentNumEntrants < EMMY.entrants.maxEntrantsIncludingPetitions) && (EMMY.entrants.maxPetitionEntrants != -1)) {
        // console.log('We have max entrants but limited number of entrants including petitions.  ie: were petitioning here.');
        $('#createNewEntrant span').text('Add petitioned entrant')
        $('.temporary-message').show();
        $('#createNewEntrant').show();
      } else if ((currentNumEntrants > EMMY.entrants.maxEntrants) && (EMMY.entrants.maxPetitionEntrants == -1)) {
        // console.log('we have max entrants but unlimited petitions ie: were petitioning here. Separate so we can control the unlimited petitions properly');
        $('#createNewEntrant span').text('Add petitioned entrant')
        $('.temporary-message').show();
        $('#createNewEntrant').show();
      } else {
        // console.log(' We have total number of entrants allowed so hide add buttons');
        $('.max-entrants').hide();
        $('#createNewEntrant').hide();
      }
    }

    if(EMMY.entrants.maxPetitionEntrants == 1) {
      $('#entrant-listing-overlimit li .action-icons .move').hide();
    }

    // If we only have one entrant hide move/delete icons
    if($('#entrant-listing-underlimit li').length == 1) {
      $('#entrant-listing-underlimit li .action-icons').css({'display': 'none'});
    } else {
      $('#entrant-listing-underlimit li .action-icons').css({'display': ''});
    }

  },
  // This is used to check the petition entrants and set the status properly
  checkPetitionEntrants: function() {
    if(EMMY.entrants.maxEntrants == 0) {
      return false;
    }
    // console.log(EMMY.entrants.maxPetitionEntrants, 'max petition', EMMY.entrants.maxEntrants)
    $('#entrant-listing-underlimit li').each(function (i, v) {
      var entrantNum = $(this).attr('data-entrant-num');
      // console.log(i, '++', entrantNum, 'this is the entrant num petition check entrants method', $(this).attr('data-entrant-num'))
      $(this).removeClass('over-petition-limit');
      $('.entrant-item.entrant-listing-item-' + entrantNum).find('.petition_dependent').hide();
      $('.entrant-item.entrant-listing-item-' + entrantNum).find('.petition_dependent .petition_description').attr('required', false);
      // console.log('is this happening????', $('.entrant-item.entrant-listing-item-' + entrantNum).find('.petition_status').val() == 'Approved')
      if($('.entrant-item.entrant-listing-item-' + entrantNum).find('.petition_status').val() != 'Approved') {
        $('.entrant-item.entrant-listing-item-' + entrantNum).find('.petition_status').val('');
      }
    });


    $('#entrant-listing-overlimit li').each(function (i, v) {
      var entrantNum = $(this).attr('data-entrant-num');
      // console.log(i, '++', entrantNum, 'this is the entrant num petition check entrants method', $(this).attr('data-entrant-num'))
      $(this).addClass('over-petition-limit');
      $('.entrant-item.entrant-listing-item-' + entrantNum).find('.petition_dependent').show();
      $('.entrant-item.entrant-listing-item-' + entrantNum).find('.petition_dependent .petition_description').attr('required', true);
    });

    // Controls the temporary message field
    if(EMMY.entrants.numCount >= (EMMY.entrants.maxEntrants-1)) {
      $('.temporary-message').show();
    }

    // This makes the dropdown for admins change the status field
    $(document).on('change', '.petition_dependent.status_field select', function() {
      var statusUpdate = $(this).val();
      $(this).closest('.entrant-item').find('input.petition_status').val(statusUpdate);
    });

      // This makes the dropdown for admins change the Appeal Status field
      $(document).on('change', '.appeal_status_field select', function() {
          var statusUpdate = $(this).val();
          $(this).closest('.entrant-item').find('input.appeal_status').val(statusUpdate);
      });




          },
  deleteEntrant: function () {
    $('.deleteEntrant').off("click", deleteClick);
    $('.deleteEntrant').on("click", deleteClick);
  },
  orderEntrant: function () {
    $('.entrant-listing li:not(.hide-me)').each(function (i, v) {
      var entrantNum = $(this).data('entrant-num');
      // console.log(i,v,entrantNum)
      if (entrantNum != 'not-saved') {
        var weightVal = $(this).index();
        var updateURL = '/entrant/' + entrantNum;
        var weightData = {'weight': weightVal};
        $.ajax({
          url: updateURL,
          method: 'PUT',
          data: weightData,
          success: function (data) {
            // console.log('Entrant upated Successfully');
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.log('Error deleting entrant');
          }
        });
      }
    });
  },
  showError: function () {
    $('.entrant-right .entrant-listing-item .form-control').each(function () {
      var entrantNum = $(this).closest('.entrant-listing-item').data('entrant-item');
      if (this.required) {
        if (this.value == '') {
          if (($(this).hasClass('choices__input')) || ($(this).parent().hasClass('easy-autocomplete')) ) {
            $(this).closest('.form-group-beside').addClass('required');
          } else {
            this.parentElement.classList.add('required');
          }
          $('.entrant-left .entrant-listing-item-' + entrantNum).addClass('needsAttention');
          EMMY.validateForm.requiredFixer();
        } else {
          if ($(this).hasClass('email')) {
            if (!EMMY.validateForm.validateEmail($.trim($(this).val()))) {
              $('.entrant-left .entrant-listing-item-' + entrantNum).addClass('needsAttention');
              EMMY.validateForm.requiredFixer();
            }
          }
        }
      }
    });
  },
  numberingEntrants: function () {
    $('#entrant-listing-underlimit li').each(function (i, v) {
      var catNumOrder = Number(i) + Number(1);
      var catElement = $(this).find('.numbering');
      catElement.text(catNumOrder + ' - ');
    });
    $('#entrant-listing-overlimit li').each(function (i, v) {
      var catNumOrder = Number(i) + Number(1);
      var catElement = $(this).find('.numbering');
      catElement.text('P' + catNumOrder + ' - ');
    });
  },
  checkNeedsAttention: function () {
    $('.entrant-right .entrant-listing-item').each(function () {
      var entrantNum = $(this).data('entrant-item');
      var numRequired = $(this).find('.form-group-beside.required').length;
      if (numRequired == 0) {
        $('.entrant-left .entrant-listing-item-' + entrantNum).removeClass('needsAttention');
      }
    });
  },
  initialDependentFieldShowHide: function() {
    var dataList = false;
    // Need to show the dependent fields here on load
    $('#entrants-form-block .right .entrant-item').each(function(ii,vv) {
      that = this;
      dataList = $(that).find(".form-group-beside, .form-group-beside-hold, .full-instructions-wrapper").map(function() {
        return $(this).data("dynamic-name");
      }).get();

      if (dataList) {
        $.each(dataList, function (i, v) {
          var dynamicElementClass = v;
          var dynamicNameID = '#field_id_' + v;
            var valueOfDynamicField = $(that).find(dynamicNameID).find('.form-control:checked').val();
            if(valueOfDynamicField != undefined) {
                var dynamicDataEqual = $(that).find('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value="' + valueOfDynamicField + '"]');
                dynamicDataEqual.show();
                var dynamicDataNotEqual = $(that).find('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value!="' + valueOfDynamicField + '"]');
                dynamicDataNotEqual.hide();
                $(that).find('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value!="' + valueOfDynamicField + '"]').find('.form-control, .requiredFile').removeAttr('required');
            } else {
                var valueOfDynamicFieldMainEntryFields = $('.main-wrapper').find(dynamicNameID).find('.form-control:checked').val();
                if($('.main-wrapper '+ dynamicNameID).length == 1) {
                    var dynamicDataEqual = $('.main-wrapper').find('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value="' + valueOfDynamicFieldMainEntryFields + '"]');
                    dynamicDataEqual.show();
                    var dynamicDataNotEqual = $('.main-wrapper').find('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value!="' + valueOfDynamicFieldMainEntryFields + '"]');
                    dynamicDataNotEqual.hide();
                    $('.main-wrapper').find('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value!="' + valueOfDynamicFieldMainEntryFields + '"]').find('.form-control, .requiredFile').removeAttr('required');
                }
            }
        });
      }
    });
  },
  dependentFields: function() {
    var allClasses = dataList = false;
    var formID = $('#entrants-form-block');
    var reloadForm = false;
    if($("#entrants-form-block .form-group-beside").val() != undefined) {
      var dataList = $('#entrants-form-block').find(".form-group-beside, .form-group-beside-hold, .full-instructions-wrapper").map(function() {
        return $(this).data("dynamic-name");
      }).get();
      if(dataList.length > 0) {
        allClasses = '.'+dataList.join(",.");
      }
    }
    $('#entrants-form-block .right .entrant-item').each(function(ii,vv) {
      var that = this;
      $(this).find('.form-control').on('change', function (e) {
        if (allClasses) {

          var changedElementGroup = $(this).attr('class').split(' ');
          var dynamicElementClass = changedElementGroup[changedElementGroup.length - 1];
          if ($(this).hasClass('toggle')) {
            var valueOfDynamicField = $(this).parent().find('.form-control:checked').val();
          } else {
            var valueOfDynamicField = $(this).val();
          }

          // This is the code when the dynamic field equals the trigger result
          // In this case we really just have to set the required fields BACK to their required state.
          var dynamicDataEqual = $(that).find('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value="' + valueOfDynamicField + '"]');
          dynamicDataEqual.show();

          dynamicDataEqual.each(function (i, v) {
            $(this).removeClass('required');
            $(this).find('.form-control, .requiredFile').removeAttr('required');
            if ($(this).find('.form-control').hasClass('toggle')) {
              $(this).find('.form-control').removeAttr('checked');
              $(this).find('.toggle-js span').removeClass('active');
            } else if ($(this).find('.form-control').hasClass('select2-hidden-accessible')) {
              $(this).find('.form-control').val('').trigger('change');
            } else if ($(this).find('.form-control').hasClass('checkbox-field-form')) {
              $(this).find('.form-control').removeAttr('checked');
            } else if ($(this).hasClass('episode_name_block')) {
              $(this).find('.episode_details:not(:first)').remove();
              $(this).find('.episode_details .form-control').val('');
              $('.episode_name_block').each(function (i, v) {
                EMMY.customFields.initialEpisodeChecker(this);
              });
            } else {
              $(this).find('.form-control').val('');
            }
            if ($(this).hasClass('dynamic-required')) {
              $(this).find('.form-control, .requiredFile').attr('required', true);
            }
          });

          // This is the code when the dynamic field DOES NOT equals the trigger result
          // In this case we must hide the field, remove the required attribute, required class (if set) and clear the data from the field.
          var dynamicDataNotEqual = $(that).find('[data-dynamic-name="' + dynamicElementClass + '"][data-dynamic-value!="' + valueOfDynamicField + '"]');
          dynamicDataNotEqual.hide();

          dynamicDataNotEqual.each(function (i, v) {
            $(this).removeClass('required');
            $(this).find('.form-control, .requiredFile').removeAttr('required');
            if ($(this).find('.form-control').hasClass('toggle')) {
              $(this).find('.form-control').removeAttr('checked');
              $(this).find('.toggle-js span').removeClass('active');
            } else if ($(this).find('.form-control').hasClass('select2-hidden-accessible')) {
              $(this).find('.form-control').val('').trigger('change');
            } else if ($(this).find('.form-control').hasClass('checkbox-field-form')) {
              $(this).find('.form-control').removeAttr('checked');
            } else if ($(this).hasClass('episode_name_block')) {
              $(this).find('.episode_details:not(:first)').remove();
              $(this).find('.episode_details .form-control').val('');
              $('.episode_name_block').each(function (i, v) {
                EMMY.customFields.initialEpisodeChecker(this);
              });
            } else if ((($(this).hasClass('uploaded')) && ($(this).hasClass('uploaded'))) || ($(this).find('.dz-max-files-reached').val() != undefined)) {
              // two if statements for when the dz is initilizaed on load and by ajax upload.
              // Here we delete the uploaded file, if necessary.
              // The actual delete happens after blur save, because we trigger a save when they toggle the conditional.
              // However, the delete creates a reload, so we don't want a race-condition so we do that in the after ajax.
              var idVal = $(this).attr('id');
              myDropzone = Dropzone.forElement('#' + idVal + ' .dropzone');
              customFieldIdHolder = $('#' + idVal).find('.form-control').data('value');
            } else {
              $(this).find('.form-control').val('');
            }
          });
        }
      });
    })
  }
}

function deleteClick() {
  // console.log('Trash has been clicked', EMMY.entrants.numCount, 'Number of entries before starting the delete');
  var actualThat = this;
  var deleteItem = $(this).closest('.entrant-listing-item');
  var deleteItemParentId = $(this).closest('.entrant-listing-parent').attr('id');
  var deleteItemIndex = Number($(this).closest('.entrant-listing-item').index()) + 1;
  // console.log(deleteItemParentId, 'id')

  var rightDeleteItemIndex = deleteItemIndex - Number(1);
  var deleteItemLeft = document.querySelector('.entrant-left .entrant-listing-item:nth-child(' + deleteItemIndex + ')');
  var deleteItemRight = document.querySelector('.entrant-right .entrant-listing-item:nth-child(' + rightDeleteItemIndex + ')');

  var entrantNum = deleteItem.attr('data-entrant-num');

  // console.log(rightDeleteItemIndex, entrantNum, 'this is the entrant num right' ,'entrant num', deleteItemLeft, ' --- ', deleteItemIndex, ' +++ ', $(this).closest('.entrant-listing-item').index())



  if ((entrantNum != 'not-saved') && (entrantNum != undefined)) {
    // console.log('This data was saved and deleting this way 22222');
    _actualAjaxDelete(entrantNum, actualThat, deleteItemParentId);
  } else {
    // console.log('This data was not saved and deleting this way 11111');
    // console.log(EMMY.entrants.numCount, 'this is the num count, are we here?', entrantNum)
    EMMY.entrants.numCount--;
    if (EMMY.entrants.numCount < 0) {
      EMMY.entrants.numCount = 0;
    }
    _entrantDeleteAndResetToFirst(entrantNum, deleteItemParentId);
    EMMY.entrants.bindListing();
    EMMY.entrants.checkEntrants();
    EMMY.entrants.checkPetitionEntrants();
  }
}

function _entrantDeleteAndResetToFirst(entrantNum, deleteItemParentId) {
  var newEntrantNum = $('.entrant-right .entrant-listing-item-' + entrantNum).prev().attr('data-entrant-item');
  $('.entrant-listing-item-' + entrantNum).remove();
  $('.entrant-left .entrant-listing-item').removeClass('active').removeClass('noclick');
  $('.entrant-right .entrant-listing-item').removeClass('active');

  $('.entrant-left .entrant-listing-item').eq(1).addClass('active');
  $('.entrant-right .entrant-listing-item').eq(0).addClass('active');

  // This logic moves the entrant from petitioned to non-petitioned if they delete a entrant higher in the list.
  // console.log(deleteItemParentId, 'parent item id', $('#entrant-listing-underlimit li').length, ' === ', EMMY.entrants.maxEntrants, ' ---- ', entrantNum)
  if((deleteItemParentId == 'entrant-listing-underlimit') && ($('#entrant-listing-underlimit li').length < EMMY.entrants.maxEntrants)) {
    var entrantNum = $('#entrant-listing-overlimit li').first().attr('data-entrant-num');
    // console.log('ok so were updating--->', entrantNum)
    $('#entrant-listing-overlimit li').first().detach().appendTo('#entrant-listing-underlimit')
    $('.entrant-right .entrant-listing-item-' + entrantNum).find('.petition_status').val('clearvalue');
    $('.entrant-right .entrant-listing-item-' + entrantNum).find('.petition_dependent .petition_description').val('');
    $('.entrant-right .entrant-listing-item-' + entrantNum).find('.petition_dependent').attr('required', false);
    $('#entrant-listing-underlimit li .action-icons .move').show();
    if($('#entrant-listing-overlimit li').length == 0) {
      $('#entrant-listing-overlimit').hide();
    }
    // console.log('start saving', EMMY.entrants.activeFormAjaxCall)
  }
  // console.log('we just deleted, now save', EMMY.entrants.ajaxBlurActiveSave)
  EMMY.drag.updateEntrantWeights();

}

function _actualAjaxDelete(entrantNum, actualThat, deleteItemParentId) {
  // console.log('We must delete by Ajax', entrantNum);

  var trashURL = '/entrant/' + entrantNum;
  $.ajax({
    url: trashURL,
    method: 'DELETE',
    data: '',
    success: function (data) {
      // console.log('Delete Successful Now the number of entries is: ', EMMY.entrants.numCount, 'entrant number clicked:', entrantNum)

      var mainWrapper = document.querySelector('.main');
      mainWrapper.className = 'main oneColumn col-8 col-md-10 editPage ' + data.status;
      $('.submission-status-value').text(data.status);

      if (EMMY.entrants.numCount == 0) {
        $('.entrant-listing-item-' + entrantNum).remove();
        bringNewFormAjaxSpecific(0);
      } else {
        _entrantDeleteAndResetToFirst(entrantNum, deleteItemParentId);
      }
      EMMY.entrants.numCount--;
      EMMY.entrants.bindListing();
      EMMY.entrants.checkEntrants();
      EMMY.entrants.checkPetitionEntrants();
      EMMY.entrants.numberingEntrants();
      EMMY.entrants.ajaxBlurActiveSave = true;
      EMMY.entrants.ajaxBlurEntrant(true);
    },
    error: function (jqXHR, textStatus, errorThrown) {
      window.location.reload(true);
      // console.log('Error deleting entrant');
    }
  });
}

function clickListing(event, that) {
  var target = event.target || event.srcElement;
  if ((target.className.indexOf('deleteEntrant') != -1) || ($(that).hasClass('noclick'))) {
    return;
  }
  $('.entrant-listing-item.active').removeClass('active');
  var activeEntrantNum = that.getAttribute('data-entrant-num');
  if (activeEntrantNum == 'not-saved') {
    $('.entrant-listing-item.not-saved, .entrant-item.not-saved').addClass('active');
  } else {
    $('.entrant-listing-item-' + activeEntrantNum).addClass('active');
  }
  EMMY.entrants.bindListing();
}

function bringNewFormAjaxSpecific(idVal) {
  EMMY.entrants.ajaxBlurActiveSave = false;
  $.ajax({
    url: '/entrant/new/' + idVal + '/' + EMMY.entrants.entryId,
    type: 'get',
    success: function (data) {
      EMMY.entrants.activeFormAjaxCall = true;
      EMMY.entrants.lowestWeightForNewForm++;
      if ($('.over-max-entrants').val() != undefined) {
        return;
      }
      if ((data.indexOf('maximum-reached') > -1) && ($('.entryAdmin').length == 0)) {
        var maxEntrantWarning = '<div class="temporary-message over-max-entrants" style="display: block;"><i class="fa icon-warning"></i><div class="message-content"><p>You have already entered the maximum entrants for this category.' +
          '<br>If you would like to petition for additional entrants, please <a href="http://www.emmys.com/entry-petition" target="_blank">download this form</a>.' +
          '</p></div></div>';
        $('.temporary-message').before(maxEntrantWarning);
        return;
      }
      var formRight = document.getElementById('right');
      $('#right .entrant-listing-item').removeClass('active');
      formRight.insertAdjacentHTML('beforeend', data);
      idVal = '';
      $('.entrant-' + idVal).addClass('active');
      EMMY.entrants.numCount++;

      $('.entrant-listing li').addClass('noclick');
      EMMY.entrants.cloneListing(idVal);
      EMMY.entrants.deleteEntrant();
      EMMY.common.selectList();
      EMMY.entrants.clickableListing();
      EMMY.entrants.bindListing();
      EMMY.entrants.checkEntrants();
      EMMY.entrants.checkPetitionEntrants();
      EMMY.entrants.ajaxBlurEntrant();
      EMMY.entrants.ajaxBlurActiveSave = true;
      EMMY.fileUpload.bindNewUploadFields();
      EMMY.entrantAutocomplete.init();
      EMMY.entrants.initialDependentFieldShowHide();
      EMMY.entrants.dependentFields();

    }
  });
}
